import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NCSARegistrationForm from './NCSARegistrationForm';
import NCSAErrorDisplay from './NCSAErrorDisplay';
import { postNCSAReg, skipNCSAReg } from '../../../actions/onboarding-actions';

import requireAuth from '../../../components/hocs/requireAuth';
import { gtag } from '../../../components/Analytics/gtag';

const NCSA = (props) => {
    const dispatch = useDispatch();
    const { auth } = props;
    const { nuo } = useSelector(({ onboarding }) => onboarding);
    const { loading, error, errorCode } = nuo || {};

    useEffect(() => {
        // segment track call
        const path = '/onboarding';
        const properties = {
            path,
            url: path,
            title: 'Onboarding NCSA Popup',
        };
        gtag('view', {
            category: 'NCSA',
            context: 'Show onboarding ncsa opt in step',
        });
        // mapped to GA4
        if (window && window.analytics) {
            window.analytics.page('Show onboarding ncsa opt in step', 'Onboarding', properties);
        }
    }, [auth?.user]);

    const onSubmit = (values) => {
        gtag('event', {
            category: 'NCSA',
            context: `Onboarding Page NCSA form submission - athleteEmail: ${values.athleteEmail}`,
            location: 'NCSA Onboarding Page CTA',
        });
        // segment track call - mapped to GA4
        if (window?.analytics) {
            window.analytics.track('Onboarding Page NCSA form submission', {
                athleteEmail: values.athleteEmail,
            });
        }

        values.ncsaEventType = 'membership-sign-up';
        dispatch(postNCSAReg(values));
    };

    const skipForm = () => {
        gtag('event', {
            category: 'NCSA',
            context: 'Onboarding Page NCSA Skip form',
        });
        // mapped to GA4
        if (window?.analytics) {
            window.analytics.track('Onboarding Page NCSA Skip form', {});
        }
        dispatch(skipNCSAReg());
    };

    const handleRefresh = () => {
        gtag('event', {
            category: 'NCSA',
            context: 'Onboarding Page NCSA Error page refresh',
        });
        // mapped to GA4
        if (window?.analytics) {
            window.analytics.track('Onboarding Page NCSA Error page refresh', {});
        }
        window.location.reload();
    };

    const defaultValues = {
        athleteFirstName: auth?.user?.firstName || '',
        athleteLastName: auth?.user?.lastName || '',
        athleteEmail: auth?.user?.email || '',
        parentEmail: auth?.user?.secondaryEmail || '',
        athleteGender: auth?.user?.gender === 'M' ? 'male' : 'female',
        athletePhone: auth?.user?.phone || '',
        zipCode: auth?.user?.location?.zipCode || '',
        isParent: false,
    };

    return (
        <div>
            {!error ? (
                <>
                    <NCSARegistrationForm
                        onsubmit={onSubmit}
                        skipForm={skipForm}
                        loading={loading}
                        defaultValues={defaultValues}
                    />
                </>
            ) : (
                <>
                    <NCSAErrorDisplay
                        handleRefresh={handleRefresh}
                        skipForm={skipForm}
                        errorCode={errorCode}
                    />
                </>
            )}
        </div>
    );
};

export default requireAuth(NCSA);
